import axios from "axios";

import { acquireAccessToken, isInteractionRequired, loginRedirect } from "../auth/msalInstance";
import { emitApiErrorToast } from "../utils/apiErrorToast";

const baseApi = process.env.REACT_APP_BASE_API || "";
const normalizedBaseApi = baseApi.replace(/\/+$/, "");
const apiBaseUrl = normalizedBaseApi.endsWith("/api")
  ? normalizedBaseApi
  : `${normalizedBaseApi}/api`;

// eslint-disable-next-line no-console
console.log("[api] base url", { apiBaseUrl });

const apiClient = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  async (config) => {
    try {
      if (config?.skipAuth) {
        return config;
      }

      // eslint-disable-next-line no-console
      console.log("[api] preparing request", { url: config?.url, baseURL: config?.baseURL });

      const tokenResult = await acquireAccessToken();

      if (tokenResult?.accessToken) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${tokenResult.accessToken}`;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("[api] auth interceptor failed", error);
      if (isInteractionRequired(error)) {
        await loginRedirect();

        return Promise.reject(new axios.Cancel("Redirecting to login"));
      }

      return Promise.reject(error);
    }

    return config;
  },
  (error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response) => {
    if (response?.config?.url?.includes("MenuItem/Grouped")) {
      // eslint-disable-next-line no-console
      console.log("[api] respuesta de MenuItem/Grouped", {
        timestamp: new Date().toISOString(),
        status: response.status,
        data: response.data,
      });
    }

    return response;
  },
  (error) => {
    const isCanceled = error?.code === "ERR_CANCELED" || axios.isCancel(error);
    const isReduxRequest = Boolean(error?.config?.reduxSourceAction);

    if (!isCanceled && !isReduxRequest) {
      emitApiErrorToast(error);
    }

    return Promise.reject(error);
  },
);

export default apiClient;
